import { AsianCompetitionHelper } from "app/helpers/asianCompetitionHelper";
import store from "app/store/store";
import { LeagueSelectorParamsType } from "app/types/apiParams";
import { getDataWithParams } from "../helpers/apiHelperV3";
import { urls } from "./urls";
export const fetchLeagues = (): any => {
  const url = urls.data.API_LEAGUESELECTION();
  const asianParams = AsianCompetitionHelper.getAsianParams(store.getState(), {
    fullList: false,
  });
  // Use the currently selected sport to get a list of available competitions for that sport
  const sportNavNodeId =
    store.getState().sportsSelectionListModel.sportNavNodeId;

  let params: LeagueSelectorParamsType = {
    live: asianParams.live,
    nonLive: asianParams.nonLive,
    before: asianParams.before,
    after: asianParams.after,
    navigationNodeIds: sportNavNodeId,
  };

  return getDataWithParams(url, params);
};
